module.exports = __webpack_public_path__ + "img/119.23d526d4.jpg";